/* Dansk katalog for locale-registry-control.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'control.example': 'Lav en faktura, opret en leverandør eller ændr e-mailadressen på en kunde …',
  'registry.customer': 'Kunder',
  'registry.supplier': 'Leverandører',
  'registry.product': 'Produkter',
  'registry.description': 'Beskrivelse',
  'registry.price': 'Enhedspris ekskl. moms',
  'registry.type': 'Type',
  'registry.vat': 'Momsbehandling',
  'registry.sku': 'SKU',
  'registry.ean': 'EAN/GTIN',
  'registry.group': 'Produktgruppe',
  'registry.goods': 'Vare',
  'registry.service': 'Tjenesteydelse',
  'registry.choose': 'Vælg …',
  'registry.newDraft': 'Ny post – ikke gemt',
  'registry.selected': 'Valgt: {name}',
  'registry.archivedLabel': 'Arkiveret',
  'registry.matches': '{count} resultater. Viser {shown}. Præciser søgningen, hvis flere passer.',
  'registry.working': 'Arbejder i registeret …',
  'registry.review': 'Kontroller oplysningerne i registerpanelet.',
  'registry.done.observed': 'Registeret er åbnet, og resultaterne er vist.',
  'registry.done.opened': 'Registerposten er åbnet.',
  'registry.repeatedRead': 'Det samme registeropslag er allerede udført. Kontroller de viste resultater, før du fortsætter.',
  'registry.done.applied': 'Felterne er udfyldt. Ændringerne er ikke gemt endnu.',
  'registry.done.saved': 'Registerposten er gemt.',
  'registry.done.archived': 'Registerposten er arkiveret.',
  'registry.done.restored': 'Leverandøren er aktiv igen.',
  'registry.done.unchanged': 'Ingen nye ændringer at gemme.',
  'registry.changed': 'Posten er ændret, siden den blev åbnet. Luk registerpanelet, og bed mig hente den igen.',
  'registry.selectFirst': 'Søg og vælg den rigtige registerpost først.',
  'registry.unsupportedField': 'Dette felt understøttes ikke her. Brug den almindelige formular på siden.',
  'registry.unsupported': 'Denne handling skal udføres i den almindelige formular på siden.',
  'registry.advancedProduct': 'Ændring af moms/type, abonnement og udlejning skal ske i den almindelige produktformular.',
  'registry.archived': 'Posten er arkiveret og kan ikke redigeres her.',
  'registry.authorization': 'Beskriv udtrykkeligt, hvad du vil gemme, arkivere eller genåbne.',
  'registry.country': 'Automatisk registergemning understøttes indtil videre for norske virksomheder. Brug den almindelige formular for denne virksomhed.',
  'registry.uncertain': 'Gemningen blev ikke bekræftet. Kontroller posten på siden, før du prøver igen.',
  'registry.unsaved': 'Der er ikke-gemte ændringer i registerpanelet. Gem eller luk panelet først.',
  'registry.duplicate': 'En anden post har samme navn eller organisationsnummer. Luk panelet, og vælg den rigtige eksisterende post, eller brug den almindelige formular.',
});
